module.exports = {
  __init__: [
    'appendBehavior',
    'copyPasteBehavior',
    'createBoundaryEventBehavior',
    'createDataObjectBehavior',
    'dropOnFlowBehavior',
    'createParticipantBehavior',
    'dataInputAssociationBehavior',
    'deleteLaneBehavior',
    'importDockingFix',
    'labelBehavior',
    'modelingFeedback',
    'removeParticipantBehavior',
    'replaceConnectionBehavior',
    'replaceElementBehaviour',
    'resizeLaneBehavior',
    'unsetDefaultFlowBehavior',
    'updateFlowNodeRefsBehavior',
    'removeElementBehavior',
    'unclaimIdBehavior',
    'toggleElementCollapseBehaviour'
  ],
  appendBehavior: [ 'type', require(33) ],
  copyPasteBehavior: [ 'type', require(34) ],
  createBoundaryEventBehavior: [ 'type', require(35) ],
  createDataObjectBehavior: [ 'type', require(36) ],
  dropOnFlowBehavior: [ 'type', require(40) ],
  createParticipantBehavior: [ 'type', require(37) ],
  dataInputAssociationBehavior: [ 'type', require(38) ],
  deleteLaneBehavior: [ 'type', require(39) ],
  importDockingFix: [ 'type', require(41) ],
  labelBehavior: [ 'type', require(42) ],
  modelingFeedback: [ 'type', require(43) ],
  removeParticipantBehavior: [ 'type', require(45) ],
  replaceConnectionBehavior: [ 'type', require(46) ],
  replaceElementBehaviour: [ 'type', require(47) ],
  resizeLaneBehavior: [ 'type', require(48) ],
  unsetDefaultFlowBehavior: [ 'type', require(51) ],
  updateFlowNodeRefsBehavior: [ 'type', require(52) ],
  removeElementBehavior: [ 'type', require(44) ],
  unclaimIdBehavior: [ 'type', require(50) ],
  toggleElementCollapseBehaviour : [ 'type', require(49) ]
};
